define('SageDotCom/Components/ModalWithButton',[
    "jquery",
    "eventManager",
    "SageDotCom/DataLayer/Global/youtube-video-tracker",
    "SageDotCom/DataLayer/Events/product-card-detail"],
    function ($, eventManager, tracker, ProductCardDetailEvent) {
        function ModalWithButton(scope) {
            var $button = $(".score-button.modal-launch-btn", scope);
            var $modalProductBtns = $(".product-card-modal .modal-footer .modal-product-btn");
            var $modal = $(".modal", scope);
            var $youtubeVideo = getYoutubeVideo($modal);
            var $brightcoveVideo = getBrightcoveVideo($modal);
            var isIframeBrightcoveVideo = setIsIframeBrightcoveVideo($brightcoveVideo);
            var $carousel = $(".score-carousel");
            var $targetParentId;
            var $productCardBundleSalesTitle = $(".product-card-modal-header h2");
            var $productCard = document.querySelector(".sage-product-card-outer");

            var focusableElements;
            var firstElement;
            var lastElement;
            var prevFocusableElement;

            if ($youtubeVideo.length === 0) {
                $youtubeVideo = $modal.find(".youtube-video-section");
            }

            // show the modal once it has been clicked
            setTimeout(function () {
                $button.on("click", function (e) {
                    e.preventDefault();

                    $targetParentId = e.target.parentNode.id;
                    if ($carousel) {

                        $modal = $modal.detach();
                        $("body").append($modal);
                        $modal.modal("show");
                        $modal.focus();

                        $carousel.carousel("pause");
                    }

                    playYoutubePlayer($youtubeVideo);
                    playBrightcovePlayer($brightcoveVideo, isIframeBrightcoveVideo);
                    // only for product card modal, set the h2's last word as Bold
                    if ($productCardBundleSalesTitle) {
                        $productCardBundleSalesTitle.html(function () {
                            const text = $(this).text().trim().split(" ");
                            const last = text.pop();
                            return text.join(" ") + (text.length > 0 ? " <span class='bolded'>" + last + "</span>" : last);
                        });
                    }

                    // Modal of product card
                    if ($productCard) {
                        setProductCardModalButtonUrls(scope);
                    }
                });

                $(".modal").on("show.bs.modal", function (e) {
                    $modal.attr("aria-hidden", false);
                    focusableElements = Array.from(e.target.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not(.chrome-ui-button):not(#chrome-url-bar)'));
                    prevFocusableElement = document.activeElement;

                    if (focusableElements != null && focusableElements.length > 0) {
                        firstElement = focusableElements[0];
                        lastElement = focusableElements[focusableElements.length - 1];
                    }

                    trapFocus(true, firstElement, lastElement, prevFocusableElement);
                });

                $modal.on("shown.bs.modal", function (e) {
                    if ($brightcoveVideo !== null && $brightcoveVideo !== undefined && $brightcoveVideo.length > 0 && isIframeBrightcoveVideo) {
                        var player = $brightcoveVideo.find("iframe") !== null && $brightcoveVideo.find("iframe") !== undefined ? $brightcoveVideo.find("iframe").get(0) : $brightcoveVideo.find("iframe");
                        if (player && player != null && player != undefined) {
                            var $brightCoveIframe = player.contentWindow;
                            var $brightCoveDomain = player.src;
                            setTimeout(function () {
                                var message = "playerStartTracking";
                                $brightCoveIframe.postMessage(message, $brightCoveDomain);
                                message = "playerTimeTracking";
                                $brightCoveIframe.postMessage(message, $brightCoveDomain);
                            }, 200);
                        }
                    }
                });

                // pause the video if it is closed so it doesn't keep playing
                $modal.on("hidden.bs.modal", function (e) {

                    if ($carousel)
                        $carousel.carousel("cycle");

                    if ($youtubeVideo.length > 0) {
                        pauseYoutubePlayer($youtubeVideo);
                    }
                    if ($brightcoveVideo.length > 0) {
                        pauseBrightcovePlayer($brightcoveVideo, isIframeBrightcoveVideo);
                    }

                    if ($targetParentId) {
                        var $targetBtnSelected = $("#" + $targetParentId + " .score-button");
                        if ($targetBtnSelected) {
                            $targetBtnSelected.focus();
                            var $styleBox = $targetBtnSelected.parent().closest(".score-style-box");
                            if ($styleBox)
                                $styleBox.focus();
                        }
                    }

                    trapFocus(false, firstElement, lastElement, prevFocusableElement);
                    $modal.attr("aria-hidden", true);
                });
            }, 250);

            $modalProductBtns.on("click", function (e) {
                $modal.modal("hide");
            });
        }

        function getYoutubeVideo($modal) {
            var $youtubeVideo = $modal.find(".score-youtube-video");

            if ($youtubeVideo.length === 0) {
                $modal.find('.youtube-video-button').fadeOut('fast');
                $modal.find('.video-component').fadeIn("fast");
                $youtubeVideo = $modal.find(".youtube-video-section");
            }

            return $youtubeVideo;
        }

        function getBrightcoveVideo($modal) {
            var $brightcoveVideo = $modal.find(".brightcove-media-container-js");
            if ($brightcoveVideo !== null && $brightcoveVideo.length > 0) {
                return $brightcoveVideo.find(".video-js");
            }

            $brightcoveVideo = $modal.find(".brightcove-media-container-iframe");
            if (!($brightcoveVideo)) {
                $brightcoveVideo = $modal.find(".brightcove-media-container");
            }
            return $brightcoveVideo;
        }

        function setIsIframeBrightcoveVideo($brightcoveVideo) {
            if ($brightcoveVideo !== undefined && $brightcoveVideo !== null && $brightcoveVideo.length > 0) {
                return $brightcoveVideo.parents(".brightcove-media-container-js") !== null && $brightcoveVideo.parents(".brightcove-media-container-js").length > 0 ? false : true;
            }
            return null;
        }

        // When dealing with carousel or tabset it can remove the player and then reattach 
        // causing issues with finding the ccf_module.   This is the workaround for it
        // OnReady didn't seem to work so changed the iframe url to include autoplay to force it to work
        function playYoutubePlayer(youtubeVideo) {
            if (youtubeVideo.length > 0) {
                var $youtubeCCFModule = youtubeVideo.data("ccf_module");
                var iframeObj = youtubeVideo.find("iframe").get(0);
                var newSrc = iframeObj.src.replaceAll(":443", "");

                if ($youtubeCCFModule) {
                    iframeObj.src = newSrc;

                    $youtubeCCFModule.player.addEventListener(
                        "onReady",
                        function (ytModule) {
                            ytModule.play();
                        }.bind(this, $youtubeCCFModule)
                    );
                } else {
                    // Set the iframe to autoplay=1 so it will play the video when loaded
                    var currentURL = newSrc;

                    if (currentURL.indexOf("autoplay=") === -1) {
                        //autoplay not present in src; so lets add it
                        if (currentURL.indexOf("?") === -1)
                            currentURL = currentURL + "?autoplay=1&mute=1";
                        else
                            currentURL = currentURL + "&autoplay=1&mute=1";
                    }
                    else {
                        if (currentURL.indexOf("autoplay=1") === -1) {
                            //replace autoplay=0 with autoplay=1
                            currentURL = currentURL.replace("autoplay=0", "autoplay=1");
                            currentURL = currentURL.replace("autoplay=", "autoplay=1");
                        }
                    }

                    iframeObj.src = currentURL; //set the newer src to iframe
                }

                setTimeout(new tracker().start, 0);
            }
        }

        // When dealing with carousel or tabset it can remove the player and then reattach 
        // causing issues with finding the ccf_module.   This is the workaround for it
        function pauseYoutubePlayer(youtubeVideo) {
            if (youtubeVideo.length > 0) {
                var $youtubeCCFModule = youtubeVideo.data("ccf_module");
                if ($youtubeCCFModule) {
                    $youtubeCCFModule.pause();
                } else {
                    var $youtubeIframe = youtubeVideo.find("iframe").get(0).contentWindow;
                    if ($youtubeIframe) {

                        $youtubeIframe.postMessage(
                            JSON.stringify(
                                {
                                    'event': "command",
                                    'func': "pauseVideo",
                                    'args': [],
                                    'id': "test-player"
                                }), "*");
                    }
                }
            }
        }

        function playBrightcovePlayer(brightcoveVideo, isIframeBrightcoveVideo) {
            if (brightcoveVideo.length > 0) {
                if (!isIframeBrightcoveVideo) {
                    // must be JS video
                    var video = videojs.getPlayer(brightcoveVideo.attr("id"));
                    video.muted(true);
                    video.play();
                   
                }
            }
        }

        function pauseBrightcovePlayer(brightcoveVideo, isIframeBrightcoveVideo) {
            if (brightcoveVideo.length > 0) {
                if (isIframeBrightcoveVideo) {
                    var $brightCoveIframe = brightcoveVideo.find("iframe").get(0);
                    if ($brightCoveIframe.contentWindow) {

                        $brightCoveIframe.contentWindow.postMessage(
                            "pauseVideo", $brightCoveIframe.src
                        );
                    }
                }
                else {
                    // must be JS video
                    var videoId = brightcoveVideo.attr("id");
                    videojs.getPlayer(videoId).pause();
                }                
            }
        }

        function trapFocus(isModalOpen, firstElement, lastElement, prevFocusableElement) {
            const handleFocus = e => {

                if (e.keyCode == 9) {
                    if (!e.shiftKey && $(e.target).is(lastElement)) {
                        e.preventDefault();
                        firstElement.focus();
                    } else if (e.shiftKey && $(e.target).is(firstElement)) {
                        e.preventDefault();
                        lastElement.focus();
                    }
                }
            };

            if (isModalOpen) {
                firstElement.focus();
                document.addEventListener("keydown", handleFocus, true);
            }
            else {
                document.removeEventListener("keydown", handleFocus, true);
                prevFocusableElement.focus();
            }
        }

        //for Modal of product card: sets the pop-up buttons links
        function setProductCardModalButtonUrls(scope) {
            var productCardWrapper = document.querySelector("#" + scope.id).closest(".sage-product-card-wrapper-alt");
            if (productCardWrapper) {
                var productBuyButton = productCardWrapper.querySelector(".product-card-cta-primary-alt, .product-card-cta-secondary-alt");
                if (productBuyButton) {
                    var tierIndex = 1;
                    var optionsDropdown = productCardWrapper.querySelector(".sage-product-card-price-selection .price-ddl");
                    if (optionsDropdown && optionsDropdown.selectedIndex != null) {
                        tierIndex = optionsDropdown.selectedIndex + 1;
                    }
                    //set the NO THANKS url:
                    var buyProductHref = productBuyButton.getAttribute("href");
                    if (buyProductHref && buyProductHref.length > 0) {
                        var noThanksButton = document.querySelector(".modal[aria-labelledby='" + scope.id + "-Label'] .modal-product-btn.button-tertiary");
                        if (noThanksButton) {
                            if (tierIndex > 1) {
                                var updatedBuyProductHref = updateQueryStringParameter(buyProductHref, "vid", tierIndex);
                                noThanksButton.setAttribute("href", updatedBuyProductHref);
                            } else {
                                noThanksButton.setAttribute("href", buyProductHref);
                            }
                        }
                    }
                    //set the BUNDLE url:
                    var addDualProductButton = document.querySelector(".modal[aria-labelledby='" + scope.id + "-Label'] .modal-product-btn.button-checkout");
                    if (addDualProductButton) {
                        var dropdownSelectValue = "";
                        if (optionsDropdown) {
                            dropdownSelectValue = optionsDropdown.options[optionsDropdown.selectedIndex].value;
                        }
                        var bundleBaseUrl = getBundleUrl(scope, dropdownSelectValue);
                        addDualProductButton.setAttribute("href", bundleBaseUrl);
                        triggerProductCardDetailEvent(scope, "modal window", addDualProductButton.getAttribute("href"), buyProductHref);
                    }
                }
            }
        }
        function triggerProductCardDetailEvent(scope, trigger, productCardUrl, originalProductUrl) {
            const productService = new ProductCardDetailEvent();
            var sku = "", originalSku = "", locale = "", promoCode = "";

            //Get variables to send to product service for product info
            productCardUrl = productService.parseURL(productCardUrl);
            productCardUrl = productCardUrl.substring(1);
            const slashIndex = productCardUrl.indexOf("/");
            sku = productService.parseUrlData(productCardUrl, "sku");
            originalSku = productService.parseUrlData(originalProductUrl, "sku");
            locale = productCardUrl.substring(0, slashIndex);
            promoCode = productService.parseUrlData(productCardUrl, "promoCode");

            //Make call to tealium
            productService.productDetailEvent(sku, originalSku, promoCode, locale, trigger, true);
        }
        function updateQueryStringParameter(uri, key, value) {
            var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
            var separator = uri.indexOf("?") !== -1 ? "&" : "?";
            if (uri.match(re)) {
                return uri.replace(re, "$1" + key + "=" + value + "$2");
            }
            else {
                return uri + separator + key + "=" + value;
            }
        }
        function getBundleUrl(scope, dropdownSelectedValue) {
            var bundleUrl = "";
            var urlVariances = $(scope).parent().find("*[data-pd-url-variances][id^=productbuybutton]:not(.modal-footer *[data-pd-url-variances][id^=productbuybutton])");
            if (urlVariances) {
                var urlVariancesData = urlVariances.data("pd-url-variances");
                if (urlVariancesData) {
                    urlVariances.each(function (i, item) {
                        $($(item).data("pd-url-variances")).each(function (k, kitem) {
                            var selAddon = kitem[0];
                            var selDropdown = kitem[1];
                            var selExternal = kitem[2];
                            var selValue = kitem[3];
                            if (selDropdown !== "" && selDropdown === dropdownSelectedValue && selAddon === "addon" && selExternal === "product card 1st option") {
                                bundleUrl = unescape(selValue);
                            } else if ((selDropdown === "" || dropdownSelectedValue === "") && selAddon === "addon" && selExternal === "product card 1st option") {
                                bundleUrl = unescape(selValue);
                            }
                        });
                    });
                }
            }
            return bundleUrl;
        }

        ModalWithButton.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new ModalWithButton(args.scope);
        };

        return ModalWithButton;
    });

